export { capture, identifyUser } from './capture'
export { PostHogProvider } from './provider'
